'use client';

import { DistributorShop, Handset } from '@sgcmpteltd/uikit-react';

import { ImageWithFallback } from '@/components/image-with-fallback';
import { joinSgcmMedia } from '@/utils/url/join/public';

import { ICON_SIZE } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const DealerDetail: Component = ({
  dealerDetailDataList,
}) => (
  <main className={styles.containerRoot}>
    <div className={styles.containerDealerDetail}>
      {dealerDetailDataList?.map(dealer => dealer.serviceCentres.map(
        serviceCentre => (
          <div
            key={dealer.id}
            className={styles.containerDealer}>
            <div className={styles.textDealerName}>
              {`${dealer.name} Showrooms`}
            </div>
            <div className={styles.containerInfo}>
              <DistributorShop
                className={styles.buttonAdFeature}
                size={ICON_SIZE} />
              <div className={styles.textSeverName}>
                {serviceCentre.name}
              </div>
            </div>
            <div className={styles.containerInfo}>
              <ImageWithFallback
                alt="location icon"
                height={ICON_SIZE}
                src={`${joinSgcmMedia('/public/new-cars/icon/outlinedLocation.svg')}`}
                title="pricelist"
                width={ICON_SIZE}
                priority />
              <div className={styles.textAddress}>
                {`${serviceCentre.address.location}
                    ${serviceCentre.address.building}
                    S(${serviceCentre.address.postalCode})`}
              </div>
            </div>
            <div className={styles.containerInfo}>
              <div
                className={styles.containerDealerInfoIcon}>
                <Handset
                  size={ICON_SIZE} />
              </div>
              <ul
                className={styles.listDealerPhoneNumber}>
                {
                  serviceCentre.hotlines.map(
                    phoneNumber => (
                      <li
                        key={phoneNumber}
                        className={styles
                          .containerDealerPhoneNumber}>
                        {`${phoneNumber.slice(0, 4)} ${phoneNumber.slice(4)}`}
                      </li>
                    ),
                  )
                }
              </ul>
            </div>
          </div>
        ),
      ))}
    </div>
    <div className={styles.containerTermsCondition}>
      { dealerDetailDataList
      && dealerDetailDataList[0].termsConditions.length > 0
      && (
        <div className={styles.textTerms}>Terms & Conditions</div>
      )}
      { dealerDetailDataList && dealerDetailDataList!.length > 1
        ? (
          <div className={styles.textConditions}>
            {
              dealerDetailDataList[1].termsConditions.map(
                condition => (
                  <div key="">
                    <div dangerouslySetInnerHTML={{ __html: condition }} />
                  </div>
                ),
              )
            }
          </div>
        )
        : (
          <div className={styles.textConditions}>
            {
              dealerDetailDataList![0].termsConditions.map(
                condition => (
                  <div key="">
                    <div dangerouslySetInnerHTML={{ __html: condition }} />
                  </div>
                ),
              )
            }
          </div>
        ) }
    </div>
  </main>
);
